<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 知识库管理 > 生活指导
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line" label="类型">
								<el-select v-model="searchData.type" @change="changeType" placeholder="请选择类型">
									<el-option value="">请选择</el-option>
									<el-option v-for="(item, index) in typeList" :key="index" :label="item.label"
										:value="item.label">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line" label="人体部位">
								<el-select v-model="searchData.bodyPart" @change="changeBodyPart" placeholder="请选择人体部位">
									<el-option value="">请选择</el-option>
									<el-option v-for="(item, index) in bodyList" :key="index" :label="item.label"
										:value="item.label">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="addBtn" @click="add">新增</el-button>
								<el-button size="large"  class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="80">
							</el-table-column>
							<el-table-column align="center" label="人体部位" prop="bodyPart">
							</el-table-column>
							<el-table-column align="center" label="类型" prop="type">
							</el-table-column>

							<el-table-column align="center" label="操作" width="100">
								<template #default="{row}">
									<span class="editor" @click="edit(row)">
										编辑
									</span>
									<span class="del" @click="del(row)">
										删除
									</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" layout="prev, pager, next, jumper"
										:total="total" :page-size="10"></el-pagination>
								</div>
								<div class="data">
									共
									<span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增生活指导' : '编辑生活指导'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item class="el-form-item-line" label="人体部位" prop="bodyPart">
									<el-select :disabled="addOrEdit == 'edit'" v-model="addUserForm.bodyPart"
										placeholder="请选择类型">
										<el-option v-for="(item, index) in bodyList" :key="index" :label="item.label"
											:value="item.label">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="类型" prop="type">
									<el-select :disabled="addOrEdit == 'edit'" v-model="addUserForm.type"
										placeholder="请选择类型">
										<el-option v-for="(item, index) in typeList" :key="index" :label="item.label"
											:value="item.label">
										</el-option>
									</el-select>
								</el-form-item>
								<div v-if="addUserForm.type == '音乐疗法'">
									<el-form-item label="听" prop="listen">
										<el-input class="longInput" v-model="addUserForm.listen"></el-input>
									</el-form-item>
									<el-form-item label="念" prop="read">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.read"></el-input>
									</el-form-item>
									<el-form-item label="乐器" prop="instrument">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.instrument"></el-input>
									</el-form-item>
									<el-form-item label="上传音乐" prop="path">
										<el-upload class="upload-demo" drag action=" " :http-request="getFile"
											accept=".CD,.WAV,.MP3,.mp3,.wav,.cd" :file-list="fileList">
											<i class="el-icon-upload"></i>
											<div class="el-upload__text">
												将文件拖到此处，或<em>点击上传</em>
												<br />
												<span
													style="font-size: 12px;color: #ccc;">支持CD/WAV/MP3格式上传,文件大小不超过10M</span>
											</div>
										</el-upload>
									</el-form-item>
									<el-form-item label="音乐名称" prop="musicName">
										<el-input class="longInput" v-model="addUserForm.musicName"></el-input>
									</el-form-item>
								</div>
								<div v-if="addUserForm.type == '养生推荐'">
									<el-form-item label="功效" prop="effect">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.effect"></el-input>
									</el-form-item>
									<el-form-item label="图片" prop="pic">
										<el-autocomplete  popper-class="my-autocomplete" v-model="addUserForm.pic"
											:fetch-suggestions="querySearch" placeholder="请输入内容" @select="handleSelect">
											<template #prefix>
											    <el-icon class="el-input__icon"><Search></Search></el-icon>
											</template>
											<template #default="{item}">
												<div class="img">
													<img :src="globalImageUrl + item.path" />
													<span class="name">{{ item.name }}</span>
												</div>
											</template>
										</el-autocomplete>
										<span class="more" style="margin-left: 10px;color: #999;">最多可选3张</span>
									</el-form-item>
									<div class="select" v-if="selectedPicList.length > 0">
										<ul class="select-ul">
											<li v-for="(item, index) in selectedPicList" :key="index">
												<div class="path">
													<img :src="globalImageUrl + item.path" />
												</div>
												<span class="name">{{ item.name }}</span>
											</li>
										</ul>
										<ul class="selected-ul">
											<span class="span">已选择的图片：</span>
											<div class="li">
												<li v-for="(item, index) in selectedPicList" :key="index">
													<span class="name">{{ item.name }}</span>
													<i @click="handleClose(item)" class="el-icon-circle-close">
														<CircleClose style="width:14px;float: left;margin-top: 8px;"></CircleClose>
													</i>
												</li>
											</div>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</el-form>
				</div>
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import globle from "../../globle/globle";
	export default {
		data() {
			return {
				total: 0,
				currentPage: 1,
				pages: 1,
				role: "",
				tabList: [{
						id: 0,
						name: "饮食推荐",
					},
					{
						id: 1,
						name: "体质管理",
					},
					{
						id: 2,
						name: "选项维护",
					},
					{
						id: 3,
						name: "健康评估",
					},
					{
						id: 4,
						name: "穴位维护",
					},
					{
						id: 5,
						name: "运动健康",
					},
					{
						id: 6,
						name: "生活指导",
					},
					{
						id: 7,
						name: "药食管理",
					},
					{
						id: 8,
						name: "图片管理",
					},
					{
						id: 9,
						name: "视频管理",
					},
				],
				currentTabIndex: 6,
				searchData: {
					bodyPart: "", //脉诊结果
					type: "",
				},
				tableListData: [],
				pulseList: [],
				addUserForm: {
					type: "音乐疗法", //类型
					bodyPart: "", //人体部位
					listen: "", //听
					read: "", //读
					instrument: "", //乐器
					musicPath: "", //音乐路径
					pic: "", //选择的图片
					musicName: "", //音乐名字
					effect: "", //功效
					id: "",
				},
				rules: {
					type: [{
						required: true,
						message: "请选择类型",
						trigger: "change",
					}, ],
					bodyPart: [{
						required: true,
						message: "请选择人体部位",
						trigger: "change",
					}, ],
					listen: [{
						required: true,
						message: "请输入听",
						trigger: "blur",
					}, ],
					read: [{
						required: true,
						message: "请输入念",
						trigger: "blur",
					}, ],
					instrument: [{
						required: true,
						message: "请输入乐器",
						trigger: "blur",
					}, ],
					effect: [{
						required: true,
						message: "请输入功效",
						trigger: "blur",
					}, ],
				},
				addOrEdit: "",
				addUserFlag: false,
				picList: [],
				selectedPicList: [], //被选中的图片
				isAcupointFlag: false, //是否为穴位
				isChineseMedicineFlag: false, //是否为中成药
				typeList: [{
						label: "音乐疗法",
						id: "0",
					},
					{
						label: "养生推荐",
						id: "1",
					},
				],
				bodyList: [{
						label: "心",
						id: "0",
					},
					{
						label: "肝",
						id: "1",
					},
					{
						label: "脾",
						id: "2",
					},
					{
						label: "肺",
						id: "3",
					},
					{
						label: "肾",
						id: "4",
					},
				],
				fileData: null, //文件
				fileList: [],
				fileObj: null,
				globalImageUrl: globle.imgPath,
				imageUrl: "",
			};
		},

		methods: {
			//路由切换
			goOther(index, id) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/knowledgeManagement/dietRecommend",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/knowledgeManagement/constituteManagement",
					});
				}
				if (index == 2) {
					this.$router.push({
						path: "/knowledgeManagement/optionManagement",
					});
				}
				if (index == 3) {
					this.$router.push({
						path: "/knowledgeManagement/healthAssessment",
					});
				}
				if (index == 4) {
					this.$router.push({
						path: "/knowledgeManagement/physiothMainten",
					});
				}
				if (index == 5) {
					this.$router.push({
						path: "/knowledgeManagement/sportsHealth",
					});
				}
				if (index == 6) {
					this.$router.push({
						path: "/knowledgeManagement/lifeGuidance",
					});
				}
				if (index == 7) {
					this.$router.push({
						path: "/knowledgeManagement/drugManagement",
					});
				}
				if (index == 8) {
					this.$router.push({
						path: "/knowledgeManagement/picManagement",
					});
				}
				if (index == 9) {
					this.$router.push({
						path: "/knowledgeManagement/videoManagement",
					});
				}
			},
			//重置
			reset() {
				this.searchData = {
					bodyPart: "", //脉诊结果
					type: "",
				}
				this.searchPluse();
			},
			//新增脉象
			add() {
				this.addUserFlag = true;
				this.addUserForm.type = "音乐疗法";
				this.addUserForm.bodyPart = "";
				this.addUserForm.listen = "";
				this.addUserForm.read = "";
				this.addUserForm.instrument = "";
				this.addUserForm.pic = "";
				this.addUserForm.musicPath = "";
				this.addUserForm.musicName = "";
				this.addUserForm.id = "";
				this.addUserForm.effect = "";
				this.selectedPicList = [];
				this.fileData = null;
				this.addOrEdit = "add";
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},
			//编辑脉象
			edit(item) {
				this.addOrEdit = "edit";
				this.addUserForm.type = item.type;
				if (this.addUserForm.type == "音乐疗法") {
					this.getDetail(item.id);
				} else {
					this.getHealthDetail(item.id);
				}
			},
			//获取详情
			getDetail(id) {
				this.$applicationJson("/business/base/life/guide/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserFlag = true;
							this.addUserForm = {
								type: item.type,
								bodyPart: item.bodyPart,
								listen: item.listen,
								read: item.read,
								instrument: item.instrument,
								musicName: item.musicName,
								musicPath: item.musicPath,
								id: item.id,
							};
							this.fileList = [];
							var obj = {
								name: item.musicName,
								url: item.path,
							};
							this.fileList.push(obj);
							this.fileData = new FormData();
							if (item.images) {
								this.selectedPicList = item.images;
							}

							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//养生推荐
			getHealthDetail(id) {
				this.$applicationJson("/business/base/wellness/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserFlag = true;
							this.addUserForm = {
								type: item.type,
								bodyPart: item.bodyPart,
								effect: item.content,
								id: item.id,
							};
							this.fileList = [];
							var obj = {
								name: item.musicName,
								url: item.path,
							};
							this.fileList.push(obj);
							this.fileData = new FormData();
							if (item.images) {
								this.selectedPicList = item.images;
							}

							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//删除脉象
			del(item) {
				this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						if (this.searchData.type == "音乐疗法") {
							this.delUserInfo(item.id);
						} else {
							this.delHealthInfo(item.id);
						}
					})
					.catch(() => {});
			},
			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},
			getFile(file) {
				var fileObj = file.file;
				this.fileObj = fileObj;
				const isLt20M = fileObj.size / 1024 / 1024 < 10;
				if (!isLt20M) {
					this.$message.error("上传文件的大小不能超过10M!");
					return false;
				}
				this.fileList = [];
				// FormData 对象
				this.fileList.push({
					name: fileObj.name,
					url: fileObj.url,
				});
				this.addUserForm.musicName = fileObj.name.split(".")[0];
				this.fileData = new FormData(); //  用FormData存放上传文件
				this.fileData.append("file", fileObj);
				this.uploadFile();
			},
			//封面上传
			uploadFile() {
				this.$multipartPost("/business/base/life/guide/upload", this.fileData)
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.imageUrl = res.data.msg;
							this.addUserForm.musicPath = res.data.msg;
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						console.log(Error);
					});
			},
			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				if (this.searchData.type == "音乐疗法") {
					this.getPlanList(this.currentPage);
				} else {
					this.getHealthList(this.currentPage);
				}
			},
			//确定
			addPatient(formName) {
				//this.$forceUpdate();
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addOrEdit == "add" && this.addUserForm.type == "音乐疗法") {
							this.addUserInfo();
						}
						if (this.addOrEdit == "edit" && this.addUserForm.type == "音乐疗法") {
							this.editUserInfo();
						}
						if (this.addOrEdit == "add" && this.addUserForm.type == "养生推荐") {
							this.addHealthInfo();
						}
						if (this.addOrEdit == "edit" && this.addUserForm.type == "养生推荐") {
							this.editHealthInfo();
						}
						this.currentPage = 0;
					} else {
						return false;
					}
				});
			},
			//新增
			addUserInfo() {
				this.$applicationJson("/business/base/life/guide/add", {
						type: this.addUserForm.type, //类型
						bodyPart: this.addUserForm.bodyPart, //人体部位
						listen: this.addUserForm.listen, //操作穴位
						read: this.addUserForm.read, //操作原则
						instrument: this.addUserForm.instrument, //功效
						musicPath: this.addUserForm.musicPath, //注意事项
						musicName: this.addUserForm.musicName, //禁忌症
						id: "",
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getPlanList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑
			editUserInfo() {
				this.$applicationJson("/business/base/life/guide/edit", {
						type: this.addUserForm.type, //类型
						bodyPart: this.addUserForm.bodyPart, //人体部位
						listen: this.addUserForm.listen, //操作穴位
						read: this.addUserForm.read, //操作原则
						instrument: this.addUserForm.instrument, //功效
						musicPath: this.addUserForm.musicPath, //注意事项
						musicName: this.addUserForm.musicName, //禁忌症
						id: this.addUserForm.id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getPlanList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//删除
			delUserInfo(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/life/guide/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.getPlanList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//新增身推荐
			addHealthInfo() {
				this.$applicationJson("/business/base/wellness/add", {
						type: this.addUserForm.type, //类型
						bodyPart: this.addUserForm.bodyPart, //人体部位
						content: this.addUserForm.effect, //功效
						images: this.selectedPicList,
						id: "",
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getHealthList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑身推荐
			editHealthInfo() {
				this.$applicationJson("/business/base/wellness/edit", {
						type: this.addUserForm.type, //类型
						bodyPart: this.addUserForm.bodyPart, //人体部位
						content: this.addUserForm.effect, //功效
						id: this.addUserForm.id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getHealthList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//删除养生推荐
			delHealthInfo(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/wellness/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.getHealthList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//搜索
			searchPluse() {
				if (this.searchData.type == "音乐疗法") {
					this.getPlanList(0);
				} else {
					this.getHealthList(0);
				}
			},
			//获取脉象列表
			getPlanList(currentPage) {
				this.$applicationJson("/business/base/life/guide/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							bodyPart: this.searchData.bodyPart,
							type: this.searchData.type,
						},
						size: 10,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//获取养生推荐
			getHealthList(currentPage) {
				this.$applicationJson("/business/base/wellness/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							bodyPart: this.searchData.bodyPart,
							type: this.searchData.type,
						},
						size: 10,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取图片列表
			getImageList(currentPage) {
				this.$applicationJson("/business/base/image/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: "",
						},
						size: 1000,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.picList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			querySearch(queryString, cb) {
				var picList = this.picList;
				var results = queryString ?
					picList.filter(this.createFilter(queryString)) :
					picList;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			//图片搜索
			createFilter(queryString) {
				return (picList) => {
					return (
						picList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
					);
				};
			},
			//图片选择
			handleSelect(item) {
				this.selectedPicList.push(item);
				if (this.selectedPicList.length == 2) {
					return false;
				}
			},
			//图片关闭
			handleClose(tag) {
				this.selectedPicList.splice(this.selectedPicList.indexOf(tag), 1);
			},
			//搜索切换类型
			changeType(val) {
				if (val == "音乐疗法") {
					this.getPlanList(0);
				} else {
					this.getHealthList(0);
				}
				this.currentPage = 0;
			},
			//切换
			changeBodyPart() {
				this.getPlanList(0);
				this.currentPage = 0;
			},
			//新增修改切换类型
			changeAddUserFormType(val) {},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(0, 5);
				}
				this.getImageList(0);
				this.getPlanList(0);
			});
		},
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					min-height: calc(100% - 80px);

					.search-con {
						height: 120px;
						@media screen and (min-width: 1190px) and (max-width: 1920px) {
							height: 60px;
							width: 100%;
						}
					}
				}
			}

			.about {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}

			.demo-form-inline {
				margin-top: 10px;

				:deep(.el-input__inner){
					width: 220px;
				}
			}

			.editor {
				cursor: pointer;
				color: #679ff6;
			}

			.del {
				color: #df6d78;
				cursor: pointer;
				margin-left: 10px;
			}
		}
	}

	.dialog {
		:deep(.el-dialog__body){
			padding: 0;

			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				min-height: 500px;

				.item {
					.line {
						width: 100%;
						overflow: hidden;

						&:nth-child(1) {
							margin-bottom: 20px;
						}

						.el-form-item {
							width: 100%;
						}

						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}

						.dialog-tit {
							height: 40px;
							line-height: 40px;

							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}

							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}

				.longInput {
					width: 100%;

					:deep(.el-input__inner){
						width: 100%;
					}
				}

				.smallInput {
					width: 150px;

					:deep(.el-input__inner){
						width: 100%;
					}
				}
			}
		}
	}

	.img {
		margin-bottom: 10px;
		float: left;

		img {
			float: left;
			width: 40px;
		}

		span {
			float: left;
			margin-left: 10px;
			width: calc(100% - 50px);
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
	}

	.select {
		margin-left: 40px;
		width: calc(100% - 40px);

		ul {
			float: left;
			width: 100%;
			margin-bottom: 20px;

			li {
				float: left;
				width: 120px;
				text-align: center;

				.path {
					img {
						width: 40px;
						margin-left: 40px;
						max-height: 40px;
					}

					width: 40px;
					height: 40px;
				}

				span {
					margin-left: 10px;
					width: calc(100% - 50px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					display: inline-block;
				}
			}
		}

		.selected-ul {
			float: left;
			width: 100%;
			margin-left: 40px;

			.span {
				float: left;
				width: 100px;
				line-height: 30px;
			}

			.li {
				float: left;
				width: calc(100% - 110px);

				li {
					border: 1px solid #eee;
					line-height: 30px;
					margin-right: 10px;
					width: auto;
					padding: 0 10px;

					span {
						width: 80px;
						float: left;
						line-height: 30px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}

					i {
						cursor: pointer;
						margin-left: 8px;
						color: #333;
						float: left;
						line-height: 30px;
					}
				}
			}
		}
	}
</style>
